// export default App;
import React from 'react';
import { ChakraProvider, Box, extendTheme } from '@chakra-ui/react';
import Header from './components/Header';
import PomodoroTimer from './components/PomodoroTimer';
// import BannerArea from './components/BannerArea';
import { Routes, Route, useLocation } from 'react-router-dom';
import Settings from './Settings';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import { PomodoroSettingsProvider } from './PomodoroSettingsContext';
// import Maintenance from './components/Maintenance';
import { BgmPlayer } from './components/BgmPlayer';
const App = () => {
  const location = useLocation();
  return (
    <ChakraProvider theme={theme}>
      <PomodoroSettingsProvider>
        <Box
          className="App"
          height="100vh"
          position="relative"
          // overflow="hidden"
        >
          {location.pathname !== '/settings' && <Header />}
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <PomodoroTimer />
                  <BgmPlayer />
                </>
              }
            />
            <Route path="/settings" element={<Settings />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </Box>
      </PomodoroSettingsProvider>
    </ChakraProvider>
  );
};

const theme = extendTheme({
  styles: {
    global: {
      body: {
        // bgGradient: 'linear(to-b, #3a7bd5, #00d2ff)',
        bg: '#3a7bd5',
        // bg: 'gray.700',
        color: 'white',
      },
    },
  },
  // fonts: {
  //   heading: `'Noto Sans JP', sans-serif`,
  //   body: `'Noto Sans JP', sans-serif`,
  // },
});

export default App;
